export abstract class EnhancedModel {
    public abstract clone():any;
    protected abstract mapClone(obj:any):void;
    protected abstract mapJson(obj:any):void;
}
